// R-162 §10.1 / WU-3.8 — /admin/queue-blocks API client.
//
// Backed by the WU-3A routes at /api/admin/queue-blocks (3 endpoints):
//   GET    /api/admin/queue-blocks      → { blocks: QueueBlockRecord[] }  (active + last-30d)
//   POST   /api/admin/queue-blocks      → 201 { block } | 409 { code: "queue_already_blocked" }
//   DELETE /api/admin/queue-blocks/:id  → 200 { cleared: true } | 404 { code: "NOT_FOUND" }
//
// All three require `supervisor.queue_block` (or the `admin` blanket grant).
//
// NOTE: paths here are written WITHOUT the leading "/api" — the shared `api`
// client in `@/lib/api-client` already prefixes it. Errors surface as
// `ApiError(status, body)`; the page inspects `.status === 409` +
// `.body.code === "queue_already_blocked"` for the duplicate-block guard.
import { api } from "@/lib/api-client";

export interface QueueBlockRecord {
  id: string;
  tenantId: string;
  stepType: string;
  jobTypeId: string;
  reason: string;
  blockedBy: string;
  blockedAt: string;
  clearedAt: string | null;
  clearedBy: string | null;
}

export interface CreateQueueBlockPayload {
  stepType: string;
  jobTypeId: string;
  reason: string;
}

export const queueBlocksApi = {
  list: () => api.get<{ blocks: QueueBlockRecord[] }>("/admin/queue-blocks"),
  create: (payload: CreateQueueBlockPayload) =>
    api.post<{ block: QueueBlockRecord }>("/admin/queue-blocks", payload),
  delete: (id: string) =>
    api.delete<{ cleared: boolean }>(`/admin/queue-blocks/${id}`),
};
